"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixUnicodeOutsideText = fixUnicodeOutsideText;
const tex_syntax_1 = require("./tex-syntax");
function fixUnicodeOutsideText(tex) {
    return tex
        .replace(textWithUnbracedLigatureUnicodeArg, "$1{$2}")
        .replace(ligatureUnicodeInMathMode, (match) => {
        if (match[0] === "\\") {
            // we matched a command which renders its argument in text mode.
            // Return it unchanged.
            return match;
        }
        // If we're here, the match must be unicode text which is not wrapped
        // in a text-mode command. Wrap it in \text{} so it renders correctly.
        return `\\text{${match}}`;
    });
}
// This list contains only languages that currently have exercise/article
// content on Khan Academy (as of September 2023).
const character = [
    "\\p{sc=Deva}", // Devanagari script (used for e.g. Hindi)
    "\\u0964", // A _danda_ (Devanagari punctuation mark)
    "\\p{sc=Beng}", // Bengali
    "\\p{sc=Guru}", // Gurmukhi script (used for e.g. Punjabi)
    "\\p{sc=Gujr}", // Gujarati
    "\\p{sc=Taml}", // Tamil
    "\\p{sc=Telu}", // Telugu
    "\\p{sc=Knda}", // Kannada
    "\\p{sc=Thai}", // Thai
    "\\p{sc=Mymr}", // Burmese
    "\\p{sc=Khmr}", // Khmer
].join("");
const textWithLigatures = `[${character}][\\s${character}]*`;
const fcolorbox = `\\\\fcolorbox${(0, tex_syntax_1.arg)(0)}${(0, tex_syntax_1.arg)(0)}${(0, tex_syntax_1.arg)(4)}`;
const colorbox = `\\\\colorbox${(0, tex_syntax_1.arg)(0)}${(0, tex_syntax_1.arg)(4)}`;
const otherTextModeCommand = `\\\\${tex_syntax_1.commandWithTextModeFirstArg}${(0, tex_syntax_1.arg)(4)}`;
const ligatureUnicodeInMathMode = new RegExp(`\\\\\\\\|${fcolorbox}|${colorbox}|${otherTextModeCommand}|${textWithLigatures}`, "ug");
const textWithUnbracedLigatureUnicodeArg = new RegExp(`(\\\\text)\\s*([${character}]+)`, "ug");
